import { Box, styled, Typography } from '@mui/material';
import { ManagementSectionBody, ManagementSectionContainer } from '../styles';

export const SecurityContainer = styled(ManagementSectionContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
}));

export const SecurityBody = styled(ManagementSectionBody)({
  padding: 0,
});

export const MfaSectionTitle = styled(Box)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 700,
  color: '#303c42',
  padding: '16px',
  marginTop: '8px',
  marginBottom: '12px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
}));

export const MatrixContainer = styled(Box)(() => ({
  marginLeft: '16px',
  marginBottom: '32px',
}));

export const RoleLabel = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.secondary.contrastText,
}));

export const CellControl = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const CellStateLabel = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isRequired',
})<{ isRequired?: boolean }>(({ theme, isRequired }) => ({
  fontSize: '12.5px',
  fontWeight: 600,
  color: isRequired ? theme.palette.primary.main : theme.palette.secondary.main,
}));

export const ActivationRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '16px',
  padding: '16px 18px',
  border: `1px solid ${theme.palette.info.dark}`,
  borderRadius: '8px',
  marginLeft: '16px',
  marginBottom: '22px',
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const HelpText = styled(Typography)(({ theme }) => ({
  fontSize: '12.5px',
  color: theme.palette.secondary.main,
  paddingBottom: '11px',
}));

/** Spacing only — the banner itself is the shared WarningBar. */
export const NoticeRow = styled(Box)(() => ({
  paddingLeft: '16px',
  marginBottom: '22px',
}));

export const FooterActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
}));
